'use strict';

import ready from './lib/ready';

// utilities
import 'focus-visible';


import activeAnchor from './lib/active-anchor';
import addPrintAction from './lib/add-print-action';
import fd from './lib/promise-fastdom';
import focus from './lib/focus-element';
import {delegate} from './lib/events';
import promiseIdle from './lib/promise-idle';
import initScrollingDown from './lib/scrolling-down';
import initSmoothScrollToAnchor from './lib/smooth-scroll-to-anchor';

// modules
import './lib/reveal';
import './lib/scrollbar-width';
import './lib/skips';
import './lib/seo-hidden-links';
import './fonts';

import './tac/gtm-consent';
import './tac/vimeo';
import './tac/youtube';
import './tac/gmaps';
import './tac/gtag';
import './tac';

import './accordion';
import './address-menu';
import './faq';
import './nav';
import './overlay';
import './search';
import './submenu';
import './collapsed';

ready()
    .then(promiseIdle())
    .then(function init() {

        initScrollingDown();
        initSmoothScrollToAnchor();

        // force image loading
        addPrintAction(function () {
            Array.prototype.forEach.call(document.querySelectorAll('img[loading="lazy"]'), function (node) {
                node.setAttribute('loading', 'eager');
            });
        });

        const links = document.querySelectorAll('.section-menu__link');
        if (links.length) {
            activeAnchor(links);
        }

        // #content link
        document.addEventListener('click', delegate('a[href="#content"]', function (e) {
            e.preventDefault();
            focus.call(document.getElementById('content'), true);
        }));

        fd.mutate(function () {
            document.body.style.removeProperty('opacity');
            document.body.classList.remove('loading');
        });
    });